import { type Component, h } from 'vue'

import StandaloneBuilderPreview from '../components/StandaloneBuilderPreview.vue'
import {
  type BlockCore,
  type BuilderModuleConfig,
  type ResourceCore,
} from '../types'

export const useBuilderComponents = <
  TBlock extends BlockCore,
  TResourceCreate,
  TResourceUpdate,
  TResource extends ResourceCore,
  TBlockCreate,
  TBlockUpdate,
>(
  config: BuilderModuleConfig<
    TResource,
    TResourceCreate,
    TResourceUpdate,
    TBlock,
    TBlockCreate,
    TBlockUpdate
  >
): { preview: () => Component } => ({
  preview: () => ({
    name: 'StandalonePreviewWrapper',
    props: {
      beforePreview: { required: false, type: Object },

      /**
       * Show Box Shadow
       * @public
       */
      noShadow: { default: false, type: Boolean },

      /**
       * Resource Data
       * @public
       */
      resource: { required: true, type: Object },

      /**
       * Section Data
       * @public
       */
      sections: { required: true, type: Array },
    },
    provide: {
      brandThemePath: undefined,
      previewBackgroundColor: config.options.previewBackgroundColor,
      readonly: true,
      scaling: config.options.scaling,
      storeModule: config.options.storeModule,
    },
    render() {
      const { resource, sections, noShadow } = this

      const preview = h(StandaloneBuilderPreview, {
        blockModules: config.blocks,
        noShadow,
        previewFooter: config.components.preview.footer,
        previewHeading: config.components.preview.heading,
        resource,
        sections,
      })

      const previewWrapper = config.components.preview.wrapper

      if (previewWrapper)
        return h(previewWrapper, {}, [
          ...(this.beforePreview ? [h(this.beforePreview, { resource })] : []),
          preview,
        ])

      return preview
    },
  }),
})
